import React, { useContext } from 'react';

import DraggableDialog from './DraggableDialog';
import DialogContext from '../DialogContext/DialogContext';
import { IDialogProps } from '@/@types/ui/DialogContext';
import { Box, DialogActions, DialogContent, Typography } from '@mui/material';
import DialogHeader from './DialogHeader';
import DialogToolbarButtonClose from './ToolbarButtons/DialogToolbarButtonClose';
import DialogActionButtonOK from './ActionButtons/DialogActionButtonOK';

const SimpleDialog = (props: IDialogProps) => {
  const { title, content, maxWidth } = props;

  const dialogContext = useContext(DialogContext);

  const handleDialogClose = () => {
    dialogContext.hideDialog();
  };

  return (
    <DraggableDialog open={true} fullScreen={false} maxWidth={maxWidth}>
      <DialogHeader>
        <Box display="flex" justifyContent="space-between">
          <Typography fontSize={'1.2'} variant="h6" sx={{ color: '#fafafa', marginTop: 0.5 }}>
            {title}
          </Typography>
          <DialogToolbarButtonClose onClick={(evt) => handleDialogClose()} />
        </Box>
      </DialogHeader>
      <DialogContent style={{ padding: '16px 24px 0px 24px' }}>{content}</DialogContent>
      <DialogActions>
        <DialogActionButtonOK variant="contained" onClick={(evt) => handleDialogClose()} />
      </DialogActions>
    </DraggableDialog>
  );
};

export default SimpleDialog;
